

























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { onlineColumns } from '../config/colums'
import { queryProperNoun, queryCategory, reindex } from '../../../service/proper'
import { email } from '../config/regExp'

@Component
export default class OnlineLibrary extends Vue {
  @Prop() public activeKey!: string
  @Watch('activeKey')
  handleActiveKeyChange(val) {
    if (val === '2') {
      this.renderList(1)
      this.renderCategories()
    }
  }
  private categoryOptions: any[] = []
  private word: string = ''
  private categoryId: string = ''
  private onlineColumns: any[] = onlineColumns
  private dataSource: any[] = []
  private pagination: any = {
    current: 1,
    pageSize: 20,
    total: 0,
    showTotal: (total) => `共 ${total} 条`
  }
  private async renderCategories() {
    const res = await queryCategory({})
    const { success, data } = res

    if (success) {
      this.categoryOptions = data
    }
  }
  private async renderList(page: number) {
    const options = {
      word: this.word,
      category_id: this.categoryId,
      ext_word_type: 1,
      page
    }
    const { list, total } = await queryProperNoun(options)

    this.pagination.current = page
    this.pagination.total = total
    this.dataSource = list
  }
  private handleTableChange(pagination) {
    this.renderList(pagination.current)
  }
  private handleSubmit() {
    this.renderList(1)
  }
  private mounted() {
    this.renderCategories()
    this.renderList(1)
  }

  // 重建索引
  private isModalVisibale: boolean = false
  private confirmLoading: boolean = false
  private rebuildIndex() {
    this.isModalVisibale = true
  }
  private async handleModalOk(e) {
    const emailRegExp = email

    if (!emailRegExp.test(this.mail)) {
      this.$message.info('请填写正确的邮箱格式')
      return
    }

    this.confirmLoading = true

    const options = {
      email: this.mail
    }
    const res = await reindex(options)

    if (res.success) {
      this.$message.success('重建索引成功')
    } else {
      this.$message.error('重建索引失败')
    }

    this.mail = ''
    this.confirmLoading = false
    this.isModalVisibale = false
  }
  private handleModalCancel(e) {
    this.mail = ''
    this.isModalVisibale = false
  }
  private mail: string = ''
}
